<template>
  <info-header-card :header="header" :rows="rows" >
    <template #parentId>
      <a :href="`#/managed-lists/${managedList.parent_id}`" class="btn-link">
        {{ managedList.parent 
          ? managedList.parent.description 
          : managedList.parent_id
        }}
      </a>
    </template>
  </info-header-card>
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";

export default {
  name: "ManagedListCard",
  components: {
    InfoHeaderCard
  },
  props: {
    managedList: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    header() {
      return this.managedList.description;
    },
    rows() {
      const headers = [
        {
          label: "Name",
          value: this.managedList.description
        },
        {
          label: "Type",
          value: this.managedList.type
        },
        {
          label: "Sub-type",
          value: this.managedList.sub_type
        },
        {
          label: "List",
          value: this.managedList.list
        }
      ];

      if (this.managedList.parent_id) {
        headers.push({
          label: "Parent List",
          value: this.managedList.parent_id,
          slot: "parentId"
        });
      }

      return headers;
    }
  },
};
</script>
